import Button from '@repo/ui/src/components/Button';
import { MediaType } from '@repo/ui/src/types/image';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import Image from '@repo/ui/src/components/Image/New';

interface NoResultsFoundProps {
  content?: {
    title?: string;
    text?: string;
    image?: MediaType;
  };
  clearFiltersButtonLabel?: string;
  clearFilters?: () => void;
  hasFilters?: boolean;
}

const NoResultsFound = ({
  content: { title, text, image } = {},
  clearFiltersButtonLabel,
  clearFilters,
  hasFilters,
}: NoResultsFoundProps) => {
  return (
    <div className="tw-p-20 tw-text-center">
      <ToutContent
        align="center"
        heading={title || 'No Results'}
        headingStyleVariant="h3"
        description={text || 'No results found.'}
        divider
        mb={5}
      />
      {hasFilters && (
        <div className="tw-mb-14">
          <Button onClick={clearFilters}>{clearFiltersButtonLabel || 'Clear Filters'}</Button>
        </div>
      )}
      {image?.url && <Image src={image.url} alt="" />}
    </div>
  );
};

export default NoResultsFound;
